module.exports = __webpack_public_path__ + "static/img/amg-energia-1.9559819.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/amg-energia-1.jpg
// module id = +buU
// module chunks = 1